module.exports = __webpack_public_path__ + "img/ff862050d85b0568f6c1ef1cbdc0e797.svg";